const FacebookIcon = (props: { className?: string }) => {
  const { className } = props;

  return (
    <svg className={className} fill="currentColor" width="100%" height="100%" viewBox="0 0 7 16">
      <path d="M4.563 4.964h2.295l-0.268 2.536h-2.027v7.357h-3.045v-7.357h-1.518v-2.536h1.518v-1.527q0-1.625 0.768-2.46t2.527-0.835h2.027v2.536h-1.268q-0.348 0-0.558 0.058t-0.304 0.21-0.121 0.308-0.027 0.442v1.268z" />
    </svg>
  );
};

export default FacebookIcon;
